import React from 'react';

const RowGridCalendar = ({ calendarDates, selectedDates }) => {
  return (
    <tr>
      {
        calendarDates.map((calendarDate, i) => {
          const date = calendarDate.stringISO;
          let klass = '';
          if (Array.isArray(selectedDates)) {
            if (date === selectedDates[0] || date === selectedDates[1]) {
              klass += ' selected';
            } else if (selectedDates.length === 2 && date > selectedDates[0] && date < selectedDates[1]) {
              klass += ' selected';
            }
          }
          return <td key={ i } className={ klass }></td>;
        })
      }
    </tr>
  );
};

export default RowGridCalendar;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/components/RowGridCalendar.jsx